import React from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const LabelSwitch = ({
  labels,
  value,
  disabled,
  onChange,
  _color,
  ...rest
}) => {
  const indexOfValue = labels.findIndex((label) => label.value === value);
  const classes = useStyle({ _color, length: labels.length, indexOfValue });

  const handleClick = (item) => {
    let nextIndex = item;
    if (item === value) {
      nextIndex = (indexOfValue + 1) % labels.length;
    }
    if (!disabled && onChange) {
      onChange(nextIndex);
    }
  };

  return (
    <div
      className={classes.labelSwitch}
      {...(disabled && { disabled: true })}
      {...rest}
      value={value}
    >
      {labels.map((label) => (
        <div
          key={label.name}
          role="button"
          onKeyDown={(event) => event.preventDefault()}
          tabIndex="0"
          onClick={() => handleClick(label.value)}
          className={cx('label', label.value === value && 'active')}
          aria-selected={label.value === value}>
          {label.name}
        </div>
      ))}
    </div>
  );
};

LabelSwitch.propTypes = {
  disabled: PropTypes.bool,
  _color: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  labels: PropTypes.array.isRequired,
  value: PropTypes.number,
};

LabelSwitch.defaultProps = {
  disabled: false,
  _color: 'primary',
  value: 0,
};

export default LabelSwitch;
